export const environment = {
  production: false,
  apiUrl: 'https://wa-np-d-gli.ase-np-d-treasury.appserviceenvironment.net',
} as const;
